import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CourseCard from "./NotificationCard";
import ConfirmModal from "../../../globalComponents/ConfirmModal/ConfirmModal";
import MoreModal from "../../../globalComponents/MoreModal/MoreModal";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import NotificationCard from "./NotificationCard";

const NotificationData = ({ getNextNotifications }) => {
  const { notifications, loading, hasMore } = useSelector(
    (state) => state.notifications
  );
  const [openMoreModal, setOpenMoreModal] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(1);
  const dispatch = useDispatch();

  useEffect(() => {
    if (openMoreModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "overlay";
    }
  }, [openMoreModal]);

  return (
    <InfiniteScroll
      dataLength={notifications.length}
      next={getNextNotifications}
      hasMore={hasMore}
      loader={<SmallLoading />}
      endMessage={<p style={{ textAlign: "center", fontSize: "20px" }}></p>}
      // height={scrollHeight}
      scrollThreshold={0.7}
    >
      <div style={{ padding: "16px", width: "70%" }}>
        {notifications.map((notification, i) => (
          <NotificationCard
            key={notification._id}
            data={notification}
            mode="desktop"
            cellNumber={i + 1}
            setOpenMoreModal={setOpenMoreModal}
          />
        ))}
      </div>
    </InfiniteScroll>
  );
};

export default NotificationData;
